import { createSlice } from '@reduxjs/toolkit'
import name from './name'
import { getFilter } from '../../pages/reporting/components/date-filter/util'

// Store
export const content = createSlice({
  name,
  initialState: {
    content: {
      topResources: undefined,
      topSubjects: undefined,
      topTopics: undefined,
      topPlaylists: undefined,
      resourceTypes: []
    },
    usage: {
      activeUsers: undefined,
      totalViewTime: undefined,
      activeUsersOverTime: undefined,
      resourcesViewed: undefined,
      topUsers: undefined
    },
    skillBites: {
      totalSubscriptions: undefined,
      totalCompletions: undefined,
      totalInProgress: undefined,
      subscriptionsOverTime: undefined,
      bySkillBite: undefined
    },
    usageBeta: {
      activeUsers: undefined,
      totalViewTime: undefined,
      resourcesViewed: undefined,
      averageViewTime: undefined,
      activeUsersOverTime: undefined,
      totalViewTimeOverTime: undefined,
      resourcesViewedOverTime: undefined,
      topUsers: undefined
    },
    filters: {
      ...getFilter('This Month'),
      name: 'This Month',
      userType: 'all',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }
  },
  reducers: {
    setContentTab: (state, { payload }) => {
      state.content = payload
    },
    setUsageTab: (state, { payload }) => {
      state.usage = payload
    },
    setSkillBitesTab: (state, { payload }) => {
      state.skillBites = payload
    },
    setUsageBetaTab: (state, { payload }) => {
      state.usageBeta = payload
    },
    setFilters: (state, { payload }) => {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...payload
        }
      }
    },
    reset: state => {
      state.content = {}
      state.usage = {}
    }
  }
})

export const { setContentTab, setUsageTab, setSkillBitesTab, setUsageBetaTab, setFilters, reset } = content.actions

export default content.reducer
